import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";
import axios from "axios";
import { useLocation } from 'react-router-dom'
import {BeatLoader} from 'react-spinners';
import {css} from "@emotion/core";
import { user_activities } from '../helpers/utils.js';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    color: white;
    text-align:center;
`;
class TableauReportTest extends Component{
    constructor(props) {
        super(props);
        this.state = {
            reportPermissionsArray:[],
            tableau_worksheet:[],
            project_name:"",
            loading: true,
            obj_code:''
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        console.log(stringCode);
        this.setState({
            obj_code: stringCode
        })

        this.get_trusted_token(decoded.tableau_username);
//         user_activities(1, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email)

    }

    get_trusted_token(tableau_username){
        if(tableau_username==='' || tableau_username===null || tableau_username==='null'){
            alert("Your account is not mapped with tableau user.");
            this.setState({
               loading:false,
            });
            return false;
        }

        axios.get(config.get('API_URL')+'/tableau/get-trusted-token/',

       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                tableau_username: tableau_username,
            }
        }).then(response => {
            //console.log(response.data);

            if(response.data.data!== undefined) {
                this.get_tableau_report(this.props.match.params.id);

                this.setState({
                    tableau_token:response.data.data,
                    tableau_server_url: response.data.server_url,
                    token_error:false,
                    loading:false,
                });
            } else {
                alert("Error while generating token");
                //this.get_tableau_report(this.props.match.params.id);
                //console.log("dddddddd", response.data.error.error)
                this.setState({
                    token_error:true,
                    loading:false,
                    tableau_token:response.data.data,
                    tableau_server_url: response.data.server_url

                });
            }


        }).catch(error => {
          console.log(error);
        });
    }
    get_tableau_report(view_id){
         axios.post(config.get('API_URL')+'/tableau/get-tableau-report/',
         {
            view_id:view_id
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            this.setState({
                tableau_report_name: response.data.view_name,
                tableau_report_link: response.data.url,
                workbook_name: response.data.project_name,
                workbook_kpi_id: response.data.project_id,
                worksheet_name: response.data.workbook_name,
                worksheet_kpi_id: response.data.workbook_id,
            })

            user_activities(view_id, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email)

        }).catch( err => {
            console.log(err);
        });
    }

    render() {
        let workbookUrl = "/admin/tableau-workbook/"+this.state.workbook_kpi_id;
        let worksheetUrl = "/admin/tableau-worksheet/"+this.state.worksheet_kpi_id;
        let reportUrl = this.state.tableau_server_url+"/trusted/"+this.state.tableau_token+this.state.tableau_report_link+"?:embed=yes&Store_Code="+this.state.obj_code;
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                            <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb">
                                                        <li class="breadcrumb-item">
                                                            <Link className="" to="/admin/tableau-project/" >Project</Link>
                                                        </li>
                                                        <li class="breadcrumb-item">
                                                            <Link className="" to={workbookUrl} >{this.state.workbook_name}</Link>
                                                        </li>
                                                        <li class="breadcrumb-item">
                                                            <Link className="" to={worksheetUrl} >{this.state.worksheet_name}</Link>
                                                        </li>

                                                        <li aria-current="page" class="breadcrumb-item active">{this.state.tableau_report_name}</li>
                                                    </ol>
                                                </nav>
{/*                                                 <div className="header"> */}
{/*                                                     <h4 className="title">Project</h4> */}
{/*                                                     <p className="category"></p> */}
{/*                                                 </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="header">*/}
                                {/*    <h4 className="title">Transaction</h4>*/}
                                {/*    <p className="category"></p>*/}
                                {/*</div>*/}
                                <div className="row">
                                  <BeatLoader
                                      css={override}
                                      sizeUnit={"px"}
                                      size={15}
                                      color={'#123abc'}
                                      loading={this.state.loading}
                                  />
                                    <div className="col-md-12 tableauEmbed">
                                    {this.state.loading===false && this.state.token_error===false?
                                         <iframe src={reportUrl} frameborder="0" allowfullscreen="true"></iframe>:null}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(TableauReportTest);